/**
 * @file: 满意度调查 表单 抽屉
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/8/7      1.0     First version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent,Fragment} from "react";
import {Spin,Drawer,Button,message, } from 'antd';
import PropTypes from "prop-types";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import Lang from "@/components/Lang/Lang";
import SurveyTaskFrom from "./SurveyTaskFrom"
import DopIndexAction from "../../pages/Index/dopIndex.action"
import "./surveyTaskFrom.less";

export default class SurveyTaskFromDraweSurveyTaskFromDrawerr extends PureComponent {
    static propTypes = {
        buyerSurveyTaskId: PropTypes.any.isRequired,
        item: PropTypes.object,
    };
    static defaultProps = {
        buyerSurveyTaskId: "", // 显示
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }
    /**
     * 抽屜
     * */
    showDrawer = (flag=true) => {
        this.setState({
            visibleDrawer: flag,
        });
        if(flag){
            this.getCustomer()
        }else {
            this.setState({
                questionList:[]
            })
        }
    }
    /**
     * 调研任务列表-问题列表
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8317
     */
    getCustomer() {
        this.loading(true);
        const {buyerSurveyTaskId} = this.props;
        DopIndexAction.postHttpAction("/service/mg/home/survey-task/question-list",{
            buyerSurveyTaskId:buyerSurveyTaskId,
        }).then(res=>this.getCustomerRes(res.data)).catch(err=>this.getCustomerRes(err));
    }
    getCustomerRes(res){
        this.loading(false);
        const {success,valid,models,} = res;
        if (success && valid) {
            this.setState({
             questionList:models
            })
        }
    }
    /**
     * 提交
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8333
     **/
    async postData(){
        if(this.onRefSurveyTaskFormat){
            const resAnswerItemList = await this.onRefSurveyTaskFormat.getValue();
            if(resAnswerItemList&&resAnswerItemList.length>0){
                const {buyerSurveyTaskId} = this.props;
                this.loading(true);
                DopIndexAction.postHttpAction("/service/mg/home/save-survey-answer", {
                    buyerSurveyTaskId: buyerSurveyTaskId,
                    answerItemList:resAnswerItemList
                }).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
            }
        }
    }
    handleRes(res={}){
        const {success,valid,} = res;
        if (success && valid) {
            message.success(Lang({id:"BaoCunChengGong",default:"保存成功"}));
            if(this.props.refreshPage){
                this.props.refreshPage()
            }
            this.showDrawer(false)
        }else {
            this.loading(false);
            if(res.message)message.error(res.message);
        }
    }

    loading(flag){
        this.setState({
            loading:flag
        })
    }
    onRefSurveyTask = (ref) =>  this.onRefSurveyTaskFormat = ref;
    componentWillMount() {
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const { title,item={}} = this.props;
        const { visibleDrawer=false,loading = true,  questionList=[], } = this.state;
        return (<Fragment>
            <AuthBtn icon={"ri-draft-line"} tips = {title||Lang({id:"ManYiDuDiaoCha",default:"满意度调查"})}
                     onClick={()=>this.showDrawer(true)}
                     className={"blueIconTips"}  />
            <Drawer title={<div className={"flex-item-ver-center lineH_27"}>
                                <span className={"font_18 fw_500"}>{title||Lang({id:"ManYiDuDiaoCha",default:"满意度调查"})}</span>
                                {/*<i className={"ri-history-line ml_8 black66 font_20 fw_400 cursor-p"}*/}
                                    {/*onClick={()=>this.showHistory(!visHistory)} />*/}
                        </div>}
                    width={1100}
                    rootClassName={"surveyTaskFromrWrap"}
                    maskClosable={false}
                    destroyOnClose={true}
                    onClose={()=>this.showDrawer(false)}
                    open={visibleDrawer}>
                        <Spin spinning={loading}>
                            <div className={"mainWrap black89 font_14"}>
                                <SurveyTaskFrom questionList={questionList}
                                                onRef={this.onRefSurveyTask}
                                                item={item} />
                                <div>
                                    <Button type="primary" size={"large"} onClick={()=>this.postData()} loading={loading}>
                                        <Lang id="BaoCun">保存</Lang>
                                    </Button>
                                </div>
                            </div>
                    </Spin>
            </Drawer>
        </Fragment>);
    }
}